module.exports = {
  CONNECTED_FLEET: 'connected-fleet',
  CONNECTED_PARTNER: 'connected-partner',
  PHEV_CONNECT: 'phev-connect',
};
